import { render, staticRenderFns } from "./ControlPanelAlarms.vue?vue&type=template&id=3bfbd88c&scoped=true&"
import script from "./ControlPanelAlarms.vue?vue&type=script&lang=js&"
export * from "./ControlPanelAlarms.vue?vue&type=script&lang=js&"
import style0 from "./ControlPanelAlarms.vue?vue&type=style&index=0&id=3bfbd88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfbd88c",
  null
  
)

export default component.exports